import { Component, Input } from '@angular/core'
import { User, Sex } from '../../models/user.model'

@Component({
  selector: '[ld-user-avatar]',
  template: require('./user-avatar.component.html'),
  styles: [require('./user-avatar.component.css')]
})
export class UserAvatarComponent {
  @Input('ld-user-avatar') user: User
  private Sex = Sex
}



// WEBPACK FOOTER //
// ../~/angular2-template-loader!./app/components/user-avatar/user-avatar.component.ts